module.exports = __webpack_public_path__ + "static/img/police.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/police.png
// module id = j7vg
// module chunks = 8